import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { ActiveDashboardDeal } from '../../../../types/requests';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { PaginatedResponse } from '../../../types/PaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { getDashboardActiveDeals } from '../../requests/getDashboardActiveDeals';

export const useDashboardActiveDeals = (
  params?: RequestConfig['params'],
  definition?: string,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    PaginatedResponse<ActiveDashboardDeal[]> | undefined
  >({
    queryKey: [PLUGIN_BASE_PATH, 'active-deals', params, definition],
    queryFn: () => getDashboardActiveDeals(constructGet, params, definition),
    keepPreviousData: true,
    ...options,
  });
  return {
    activeDeals: data?.data,
    meta: data?.meta,
    ...rest,
  };
};
